export enum SecurityPageTarget {
  Main = 'main',
  BO = 'BO',
  MP = 'MP',
  Corporate = 'CTA',
}
